namespace RioERP.Reports {
    export interface B2CStatewiseGstReportSummaryForm {
        BillingStateId: Serenity.LookupEditor;
        StateName: Serenity.StringEditor;
        OrderMonth: Serenity.EnumEditor;
        OrderYear: Serenity.EnumEditor;
        TaxCategoryId: Serenity.LookupEditor;
        Taxcategory: Serenity.StringEditor;
        TotalTaxableAmount: Serenity.DecimalEditor;
        TotalTaxAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class B2CStatewiseGstReportSummaryForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.B2CStatewiseGstReportSummary';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!B2CStatewiseGstReportSummaryForm.init)  {
                B2CStatewiseGstReportSummaryForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(B2CStatewiseGstReportSummaryForm, [
                    'BillingStateId', w0,
                    'StateName', w1,
                    'OrderMonth', w2,
                    'OrderYear', w2,
                    'TaxCategoryId', w0,
                    'Taxcategory', w1,
                    'TotalTaxableAmount', w3,
                    'TotalTaxAmount', w3,
                    'CgstAmount', w3,
                    'SgstAmount', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3
                ]);
            }
        }
    }
}
